<template>
    <div class="text-center">
        <h2 class="mt-3 text-center">Garage Fitting</h2>
        <p class="text-center">What do you require help with?</p>
        <div class="accordion accordion-flush" id="CSAccordion" ref="csParent">
            <div class="accordion-section">
                <div class="accordion-item" v-for="faq in faqs">
                    <h2 class="accordion-header" :id="'heading' + faq.id">
                        <button class="accordion-button collapsed mb-2 text-center" :class="accordionBg" type="button" data-bs-toggle="collapse" :data-bs-target="'#collapse' + faq.id" aria-expanded="false" :aria-controls="'#collapse' + faq.id">
                            {{ faq.question }}
                        </button>
                    </h2>
                    <div :id="'collapse' + faq.id" class="accordion-collapse collapse" :aria-labelledby="'heading' + faq.id" data-bs-parent="#CSAccordion">
                        <div class="accordion-body">
                            <div v-if="faq.question.includes('fitting time')">
                                <b class="d-block mb-3">Do you wish to make your fitting earlier or later?</b>
                                <div class="groupFour">
                                    <button type="button" class="btn me-2" :class="btnInactive" @click="e => toggleSection(e, 'earlier', 'groupFour')">Earlier</button>
                                    <button type="button" class="btn" :class="btnInactive" @click="e => toggleSection(e, 'later', 'groupFour')">Later</button>
                                </div>
                                <div v-if="visibleSection == 'earlier'">
                                    <p class="mt-3">Please note, the earliest fitting availability will have been offered to you on the website when placing an order. If you selected a later appointment and would like to bring this forward, please raise a ticket / live chat using the links above.</p>
                                </div>
                                <div v-else-if="visibleSection == 'later'">
                                    <p class="mt-3">You can do this in the <a href="/user/login">My Account</a> section.</p>
                                </div>
                            </div>
                            <div v-else v-html="faq.answer"></div>
                        </div>
                    </div>
                </div>
            </div>
            <p v-if="faqs.length == 0" class="text-center">There are no FAQ's available, please check again later.</p>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['customerServiceNumber', 'faqs', 'btnActive', 'btnInactive', 'accordionBg'],
        data() {
            return {
                visibleSection: ''
            }
        },
        methods: {
            toggleSection(e, section, group) {
                let vm = this;
                var elems = document.querySelectorAll('.' + group + ' .' + this.btnActive);

                [].forEach.call(elems, function(el) {
                    el.classList.remove(vm.btnActive);
                    el.classList.add(vm.btnInactive);
                });

                e.target.classList.remove(this.btnInactive);
                e.target.classList.add(this.btnActive);

                this.visibleSection = section;
            },
        }
    }
</script>

<style lang="scss" scoped>

</style>